<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-car-cruise-control</v-icon>{{$t('profile.controlunit.controlunits')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ControlUnitForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ControlUnitForm from '../../components/controlunit/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ControlUnit';

const { mapFields } = createHelpers({
  getterType: 'controlunit/getField',
  mutationType: 'controlunit/updateField'
});

export default {
  name: 'ControlUnitCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ControlUnitForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('controlunit', ['create', 'reset'])
  }
};
</script>
